import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { AuthService } from '../../auth-common/auth/auth.service';
import { PaginatedRepository } from '../../services/pagination/paginated.repository';
import { ToastrService } from 'ngx-toastr';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../reg-hub-common-config';
import { SubscriptionFee } from '../../interfaces/subscription-fees/subscription-fee';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionFeeRepositoryService extends PaginatedRepository<SubscriptionFee> {
  protected override _baseLink: string;
  protected rootURL: string;

  constructor(
    http: HttpClient,
    messageService: ToastrService,
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig) {
    super(
      http,
      messageService);

    this.rootURL = config.rootUrl;
    this._baseLink = `${config.rootUrl}/SubscriptionFees`;
    this._baseLinkTemplate = `${config.rootUrl}/Corporations/[0]/Invoices/[1]/SubscriptionFees`;
  }

  private generateHeaders = () => {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' })
    }
  }
}
